import {
	SHOW_ALL_ZONES_BUTTON_CONTAINER_CLASS_SELECTOR,
	SHOW_ALL_ZONES_INNER_BUTTON_CLASS_SELECTOR,
} from "./show-all-zones-selector";

export const queryShowAllZonesButton = () => {
	const containerElement = document.querySelector(
		SHOW_ALL_ZONES_BUTTON_CONTAINER_CLASS_SELECTOR
	);

	if (!containerElement) {
		return null;
	}

	const buttonElement = containerElement.querySelector(
		SHOW_ALL_ZONES_INNER_BUTTON_CLASS_SELECTOR
	);

	if (!buttonElement) {
		return null;
	}

	return buttonElement;
};
